import { render } from "./FoundersForm.vue?vue&type=template&id=623628b4&scoped=true"
import script from "./FoundersForm.vue?vue&type=script&lang=js"
export * from "./FoundersForm.vue?vue&type=script&lang=js"

import "./FoundersForm.vue?vue&type=style&index=0&id=623628b4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623628b4"]])

export default __exports__